import bankCodes from '@/languages/ko-kr/bank-codes'

export default {
  'bank': '@:terms.bank',
  'account': '@:terms.account',
  'register': '@:terms.register',
  'bank-account': '@:terms.account번호',
  'bank-codes': {
    ...bankCodes,
  },
  'fee': '계좌이체 @:terms.fee',
  'bank-accounts': {
    'title': '@:terms.client 계좌 선택',
    'add-account': '계좌 추가하기'
  },
  'bank-addition': {
    'title': ['@:terms.client에 송금할', '정보를 입력해주세요'],
    'owner-search': '예금주 확인',
    'owner': '예금주',
    'biz-book-summary': '내 통장에 표시할 적요',
    'client-book-summary': '@:terms.client 통장에 표시할 적요',
    'placeholder': {
      'biz-book-summary': '미입력 시 내 계좌 예금주명',
      'client-book-summary': '미입력 시 @:terms.client 계좌 예금주명',
    },
  },
  'btn': {
    'confirm': '확인',
    'cancel': '취소',
    'close': '닫기',
    'no': '아니오',
    'adjust': '적용',
  },
  'verification': {
    'required': {
      'number': '@:pages.banks.number를 입력해주세요.',
      'owner': '@:pages.banks.owner를 확인해주세요.',
      'bank-code': '@:terms.bank를 선택해주세요.',
    },
    'failed': {
      'owner': '@:pages.banks.owner를 찾지 못하였습니다. @:terms.bank @:pages.banks.number를 확인해주세요.',
    },
    'max-length': '7자 까지 입력 가능합니다.'
  },
  'error': {
    'owner': '@:pages.banks.owner를 조회하는데 실패하였습니다.',
    'account': '@:terms.client @:terms.account를 등록하는데 실패하였습니다.',
    'summary': '@:terms.client @:terms.account정보를 등록하는데 실패하였습니다.',
    'get-client-accounts': '@:terms.client @:terms.account정보를 불러오는데 실패하였습니다.',
  },
}
